import moment from 'moment'

const dateNow = () => {
  moment.locale('pt-br')
  var dateNow = moment().format('MMM YYYY')

  return dateNow.charAt(0).toUpperCase() + dateNow.slice(1)
}

export default dateNow
